<template>
  <div class="study_box">
    <!-- 可视化数据 -->
    <div class="echarts_box">
      <div class="echarts_cotent" v-loading="loadingBin">
        <div class="title">板块热度占比</div>
        <div id="bin" class="echarts_cotent"></div>
      </div>
      <div class="echarts_cotent_zhu" v-loading="loadingZhu">
        <div class="title">课程TOP榜</div>
        <div id="zhu" class="echarts_cotent_zhu"></div>
      </div>
    </div>
    <!-- 查询条件 -->
    <div class="study_form">
      <el-form
        :inline="true"
        label-width="80px"
        :model="searchForm"
        label-position="top"
        size="small"
      >
        <el-row>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label="用户ID/账号">
              <el-input v-model="searchForm.name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label="部门选择">
              <el-select
                v-model="searchForm.department"
                multiple
                collapse-tags
                placeholder="请选择"
              >
                <el-option
                  v-for="item in departmentList"
                  :key="item.department_id"
                  :label="item.department_name"
                  :value="item.department_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label="学习总时长">
              <!-- <el-time-picker
                is-range
                v-model="study_time"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              >
              </el-time-picker> -->
              <Timepicker
                ref="timePicker"
                @changeTime="changeTime"
                @changeTime2="changeTime2"
              />
              <!-- <el-date-picker
                v-model="study_time"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker> -->
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label="姓名">
              <el-input v-model="searchForm.nickname"></el-input>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label="最近学习时间">
              <dataPicker
                style="width: 321px"
                :datevalue.sync="searchForm.time_update"
              ></dataPicker>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12" :xs="24">
            <el-form-item label=" ">
              <el-button
                icon="el-icon-refresh"
                size="medium"
                @click="clearForm"
              >
                清除条件
              </el-button>
              <el-button
                type="goon"
                icon="el-icon-search"
                size="medium"
                @click="submitForm"
              >
                搜索
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="cotent_table">
      <el-table
        class="boder_table"
        ref="multipleTable"
        :data="tableData.data"
        tooltip-effect="dark"
        style="width: 100%"
        @selection-change="handleSelectionChange"
        @sort-change="handleSortChang"
        :default-sort="defaultSort"
        v-loading="tableData.loading"
        :row-key="getRowKey"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
          :reserve-selection="true"
        >
        </el-table-column>
        <el-table-column prop="id" label="用户ID" width="300" align="center">
        </el-table-column>
        <el-table-column
          prop="nickname"
          label="姓名"
          width="120"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="username" label="账号" align="center">
        </el-table-column>
        <el-table-column prop="department_name" label="部门" align="center">
        </el-table-column>
        <el-table-column
          prop="study_time"
          label="学习总时长"
          align="center"
          width="200"
          sortable
        >
        </el-table-column>
        <el-table-column
          prop="lately_study_time"
          label="最近学习时间"
          align="center"
          width="300"
          sortable
        >
        </el-table-column>
        <el-table-column prop="" label="操作" align="center" width="200">
          <template slot-scope="scope">
            <el-button type="text" @click="goInfo(scope.row.id)"
              >详情</el-button
            >
            <!-- <el-button type="text" @click="loginInfo">登录管理</el-button> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="table_foot">
        <!-- 按钮组 -->
        <div>
          <!--  <el-button
            size="small"
            type="goon"
            icon="el-icon-monitor"
            @click="goLoginManage"
            >登录授权管理</el-button
          > -->
          <el-button
            size="small"
            icon="el-icon-download"
            :loading="loading"
            @click="leadingOut"
            >导出</el-button
          >
        </div>
        <!-- 分页器 -->
        <div>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableOpt.page"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="tableData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="600px"
      :close-on-click-modal="false"
    >
      <div class="login_info_btn">
        <span style="padding-right: 30px">登录时需插件校验</span>
        <el-switch
          v-model="login_flag"
          active-color="#13ce66"
          inactive-color="#ff4949"
          @change="changeBtn"
          active-text="开"
          inactive-text="关"
        >
          >
        </el-switch>
      </div>
      <div style="margin-top: 20px">
        <div style="padding: 5px 0">已授权插件：</div>
        <div style="padding: 0px 10px; background: rgb(242 242 242)">
          <div
            v-for="(item, index) in UserAuthMacList"
            :key="index"
            style="
              display: flex;
              justify-content: space-between;
              padding: 10px 0;
            "
          >
            <span>{{ item.mac_no }}</span>
            <el-button size="mini" @click="deleteLogin(item)">删除</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import Timepicker from "@/components/time-picker";
import FilterLayout from "@/layout/form";
import FormatJson from "@/util/lead-out/FormatJson";
import { export_json_to_excel } from "@/util/lead-out/Export2Excel";

export default {
  components: {
    FilterLayout,
    Timepicker,
  },
  data() {
    return {
      defaultSort: {},
      departmentList: [],
      study_time: [],
      loadingBin: false,
      loadingZhu: false,
      searchForm: {
        nickname: "",
        name: "",
        department: "",
        time_update: [
        ],
      },
      tableData: {
        data: [],
        total: 0,
        page: 1,
        page_size: 10,
        loading: false,
      },
      tableOpt: {
        page: 1,
        page_size: 10,
      },
      loading: false,
      dialogVisible: false,
      UserAuthMacList: [],
      tableIds: [],
      login_flag: false,
      column: [
        {
          label: "用户ID",
          prop: "id",
        },
        {
          label: "账号",
          prop: "username",
        },
        {
          label: "部门",
          prop: "department_name",
        },
        {
          label: "姓名",
          prop: "nickname",
        },
        {
          label: "学习总时长",
          prop: "study_time",
        },
        {
          label: "最近学习时间",
          prop: "lately_study_time",
        },
      ],
      timePicker: "",
      timePicker2: "",
    };
  },
  methods: {
    getRowKey(row) {
      return row.id;
    },
    async getList() {
      let study_time = [];
      if (this.timePicker) {
        study_time = [this.timePicker, 0];
      }
      if (this.timePicker2) {
        study_time = [0, this.timePicker2];
      }
      if (this.timePicker && this.timePicker2) {
        study_time = [this.timePicker, this.timePicker2];
      }
      this.tableData.loading = true;
      const { searchForm, tableOpt, defaultSort } = this;
      const [err, res] = await this.$http.post("record/list", {
        ...searchForm,
        ...tableOpt,
        study_time_long: study_time,
        order: defaultSort.order,
        prop: defaultSort.prop,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { page, page_size, total } = res;
      let list = res.list ? res.list : [];
      let arr = [];
      if (list.length) {
        arr = list.map((item) => {
          return {
            department_name: item.department_name,
            id: item.id,
            lately_study_time: item.lately_study_time,
            nickname: item.nickname,
            study_time: item.study_time
              ? moment.utc(item.study_time * 1000).format("HH:mm:ss")
              : "00:00:00",
            username: item.username,
          };
        });
      }
      this.tableData.loading = false;
      this.tableData.data = arr ? arr : [];
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
      console.log(this.tableData.data);
    },
    async searchList() {
      let study_time = [];
      if (this.timePicker) {
        study_time = [this.timePicker, 0];
      }
      if (this.timePicker2) {
        study_time = [0, this.timePicker2];
      }
      if (this.timePicker && this.timePicker2) {
        study_time = [this.timePicker, this.timePicker2];
      }
      this.tableData.loading = true;
      const { searchForm, tableOpt, defaultSort } = this;
      const [err, res] = await this.$http.post("record/list", {
        ...searchForm,
        page: 1,
        page_size: 10,
        study_time_long: study_time,
        order: defaultSort.order,
        prop: defaultSort.prop,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { page, page_size, total } = res;
      let list = res.list ? res.list : [];
      let arr = [];
      if (list.length) {
        arr = list.map((item) => {
          return {
            department_name: item.department_name,
            id: item.id,
            lately_study_time: item.lately_study_time,
            nickname: item.nickname,
            study_time: item.study_time
              ? moment.utc(item.study_time * 1000).format("HH:mm:ss")
              : "00:00:00",
            username: item.username,
          };
        });
      }
      this.tableData.loading = false;
      this.tableData.data = arr ? arr : [];
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
    },
    async drawChart() {
      this.loadingBin = true;
      const [err, res] = await this.$http.post("record/hot_rate");
      if (err) {
        this.loadingBin = false;
        return;
      }
      let arrData = res.data.map((item) => {
        return {
          value: (item.rate * 100).toFixed(2),
          name: item.cate,
        };
      });
      let myEchart = this.$echarts.init(document.getElementById("bin"));
      myEchart.setOption({
        series: [
          {
            type: "pie",
            roseType: "area",
            radius: [25, 125],
            //  值
            data: arrData,
            itemStyle: {
              normal: {
                borderRadius: 5,
                label: {
                  show: true,
                  formatter: "{b}  {d}%", //带当前图例名 + 百分比
                },
                labelLine: { show: true },
              },
            },
          },
        ],
      });
      this.loadingBin = false;
    },
    async drawChartZhu() {
      this.loadingZhu = true;

      const [err, res] = await this.$http.post("record/course_top");
      if (err) {
        this.loadingZhu = false;
        return;
      }
      let Ydata;
      let Xdata;
      let colorList;
      if (res.data.length == 0) {
        Ydata = [];
        Xdata = [];
      } else {
        Ydata = res.data.map((item) => {
          return item.course_title;
        });
        Xdata = res.data.map((item) => {
          return item.course_pv;
        });

        colorList = res.data.map((item, index) => {
          if (res.data.length <= 3) {
            return "#2AB18B";
          } else {
            if (index >= res.data.length - 3) {
              return "#2AB18B";
            } else {
              return "#A8ABB2";
            }
          }
        });
      }
      let myEchart = this.$echarts.init(document.getElementById("zhu"));
      myEchart.setOption({
        color: colorList,
        inverse: true,
        grid: {
          left: "2%",
          right: "2%",
          bottom: "0%",
          top: "0%",
          containLabel: true,
        },
        yAxis: {
          data: Ydata,
          axisTick: {
            show: false, //刻度线
          },
          axisLine: {
            show: false, //隐藏y轴
          },
          axisLabel: {
            margin: 2,
            padding:[5,0],

            show: true,
            align: "right",
            formatter: function (params) {
              var maxLength = 10;
              //判断长度，超出使用...代替
              if (params && params.length > maxLength) {
                return params.substring(0, maxLength - 1) + "...";
              } else {
                return params;
              }
            },
          },
        },
        tooltip: {
          trigger: "item",
          formatter: function (params) {
            console.log(params);
            let tip = "";
            tip += `<div>${params.name}</div>`;
            return tip;
          },
        },
        xAxis: {
          show: false,
        },
        series: [
          {
            type: "bar",
            data: Xdata,
            barWidth: 16,

            label: {
              show: true,
              position: "right",
              color: "#000",
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  return colorList[params.dataIndex];
                },
              },
            },
          },
        ],
      });
      myEchart.getZr().on("click", (params) => {
        let pointInPixel = [params.offsetX, params.offsetY];
        if (myEchart.containPixel("grid", pointInPixel)) {
          //点击第几个柱子
          let pointInGrid = myEchart.convertFromPixel(
            { seriesIndex: 0 },
            pointInPixel
          );
          // console.log(pointInGrid)
          // 也可以通过params.offsetY 来判断鼠标点击的位置是否是图表展示区里面的位置
          // 也可以通过name[xIndex] != undefined，name是x轴的坐标名称来判断是否还是点击的图表里面的内容
          // x轴数据的索引
          let xIndex = pointInGrid[0];
          // y轴数据的索引
          let yIndex = pointInGrid[1];
          // let routeData = this.$router.resolve({
          //   path: "/count_center/player",
          //   query: {
          //     id: res.data[yIndex].id,
          //     type: 2,
          //   },
          // });
          let routeData = this.$router.resolve({
            path: `/count_center/player/${res.data[yIndex].id}/2`,
          });
          window.open(routeData.href, "_blank");
        }
      });
      this.loadingZhu = false;
    },
    async getDepartment() {
      const [err, res] = await this.$http.post("user/get_department");
      if (err) {
        return;
      }
      this.departmentList = res.list;
    },
    handleSelectionChange(data) {
      if (data.length) {
        this.tableIds = data.map((item) => {
          return item.id;
        });
      } else {
        this.tableIds = [];
      }
    },
    handleSizeChange(val) {
      console.log(val);
    },
    handleCurrentChange(val) {
      this.tableOpt.page = val;
      this.getList();
    },
    // 清除表单
    clearForm() {
      this.timePicker = "";
      this.timePicker2 = "";
      this.searchForm = {
        nickname: "",
        username: "",
        time_update: [
          moment().subtract(30, "d").format("YYYY-MM-DD"),
          moment().subtract(0, "d").format("YYYY-MM-DD"),
        ],
      };
      this.tableOpt = {
        page: 1,
        page_size: 10,
      };
      this.$refs.multipleTable.clearSort();
      this.$refs.timePicker.clearTime();
      this.getList();
    },
    submitForm() {
      this.searchList();
    },
    //导出
    async leadingOut() {
      let study_time = [];
      if (this.timePicker) {
        study_time = [this.timePicker, 0];
      }
      if (this.timePicker2) {
        study_time = [0, this.timePicker2];
      }
      if (this.timePicker && this.timePicker2) {
        study_time = [this.timePicker, this.timePicker2];
      }
      const { searchForm, tableOpt } = this;
      let column = this.column;

      this.loading = true;
      const [err, res] = await this.$http.post("record/list", {
        ...searchForm,
        ...tableOpt,
        study_time_long: study_time,
        is_download: "1",
        id: this.tableIds.length ? this.tableIds : [],
      });

      this.loading = false;

      if (err) {
        return;
      }

      console.log(res);
      const data = res["list"].map((item) => {
        return {
          department_name: item.department_name,
          id: item.id,
          lately_study_time: item.lately_study_time,
          nickname: item.nickname,
          study_time: item.study_time
            ? moment.utc(item.study_time * 1000).format("HH:mm:ss")
            : "00:00:00",
          username: item.username,
        };
      });
      console.log(data);
      if (!data || !data.length) {
        this.$notify.error({
          title: "导出提示",
          message: "未查询到数据，请更换搜索条件重新查询",
        });
        return;
      }
      const tHeader = column.map((v) => v.label);
      const filter = column.map((v) => v.prop);

      const _data = FormatJson(filter, data);
      console.log(tHeader, _data);
      export_json_to_excel(tHeader, _data, `学习记录列表`);
    },
    deleteLogin(data) {
      this.$confirm("确认删除该授权插件？", "提示")
        .then(async (_) => {
          const [err, res] = await this.$http.post("admin/del_mac", {
            mac_no: data.mac_no,
            id: data.id,
          });

          if (err) {
            this.$message({
              showClose: true,
              message: err,
              type: "error",
            });
            return;
          }
          this.$message({
            showClose: true,
            message: "删除成功",
            type: "success",
          });
          this.getUserAuthMac();
        })
        .catch((_) => {});
    },
    async changeBtn(val) {
      console.log(val);
      this.$confirm("确定更改当前用户插件校验状态？")
        .then(async (_) => {
          const [err, res] = await this.$http.post("admin/mac_open", {
            id: this.id,
            is_check: this.login_flag ? "1" : "0",
          });
          if (err) return;
          this.fetchData();
        })
        .catch((_) => {
          this.login_flag = !this.login_flag;
        });
    },
    async getUserAuthMac() {
      const [err, res] = await this.$http.post("admin/user_auth_mac", {
        id: this.id,
      });
      if (err) {
        return;
      }
      this.UserAuthMacList = res.list;
    },
    loginInfo() {
      this.dialogVisible = true;
      this.getUserAuthMac();
    },
    goLoginManage() {
      this.$router.push("/manage_center/login_manage");
    },
    goInfo(id) {
      this.$router.push({
        path: "/manage_center/study_records/info",
        query: {
          id,
        },
      });
    },
    async handleSortChang(column) {
      this.defaultSort = {
        order: column.order,
        prop: column.prop,
      };
      let study_time = [];
      if (this.timePicker) {
        study_time = [this.timePicker, 0];
      }
      if (this.timePicker2) {
        study_time = [0, this.timePicker2];
      }
      if (this.timePicker && this.timePicker2) {
        study_time = [this.timePicker, this.timePicker2];
      }
      this.tableData.loading = true;
      const { searchForm, tableOpt } = this;
      const [err, res] = await this.$http.post("record/list", {
        ...searchForm,
        ...tableOpt,
        study_time_long: study_time,
        order: column.order,
        prop: column.prop,
      });
      if (err) {
        this.tableData.loading = false;
        return;
      }
      const { list, page, page_size, total } = res;
      let arr = [];
      if (list.length) {
        arr = list.map((item) => {
          return {
            department_name: item.department_name,
            id: item.id,
            lately_study_time: item.lately_study_time,
            nickname: item.nickname,
            study_time: item.study_time
              ? moment.utc(item.study_time * 1000).format("HH:mm:ss")
              : "00:00:00",
            username: item.username,
          };
        });
      }
      this.tableData.loading = false;
      this.tableData.data = arr ? arr : [];
      this.tableOpt.page = page;
      this.tableOpt.page_size = page_size;
      this.tableData.total = total;
    },
    changeTime(val) {
      this.timePicker = val;
    },
    changeTime2(val) {
      this.timePicker2 = val;
    },
  },
  mounted() {
    this.drawChart();
    this.drawChartZhu();
    this.getDepartment();
    this.getList();
  },
};
</script>

<style lang="less" scoped>
.el-button--goon,
.el-button--goon:focus,
.el-button--goon.is-active,
.el-button--goon:active {
  background: #2ab18b;
  border-color: #2ab18b;
  color: #fff;
}
.el-button--goon:hover {
  background: #8cd8da;
  border-color: #8cd8da;
  color: #fff;
}
.el-button--goon:focus {
  background: #0a8965;
  border-color: #0a8965;
  color: #fff;
}
.study_box {
  .echarts_box {
    display: flex;
    justify-content: space-between;
    height: 474px;
    .title {
      font-size: 16px;
      font-weight: 600;
      color: #23262f;
      padding: 26px 26px 0 26px;
    }
    .echarts_cotent {
      background: #ffffff;
      width: 676px;
      height: 411px;
      box-sizing: border-box;
    }
    .echarts_cotent_zhu {
      background: #ffffff;
      width: 974px;
      height: 411px;
      box-sizing: border-box;
    }
  }
  .study_form {
    background: #fff;
    padding: 16px;
    /deep/.el-input--small .el-input__inner {
      width: 324px;
    }
    /deep/.el-form-item__label {
      min-height: 42px;
      min-width: 50px;
    }
    /deep/.el-range-editor.el-input__inner {
      padding: 2px 10px;
    }
  }
  .cotent_table {
    background: #fff;
    margin-top: 16px;
    padding: 20px;
    .table_foot {
      display: flex;
      justify-content: space-between;
      padding: 20px 0;
      /deep/.el-pager li.active {
        color: #2ab18b;
      }
      /deep/ .el-pager li:hover {
        color: #2ab18b;
      }
    }
  }
  .boder_table {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
  }
  /deep/.has-gutter tr th {
    height: 75px;
    background: #f0f2f5;
    color: #909399;
  }
  /deep/.el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #2ab18b;
    border-color: #2ab18b;
  }
  /deep/.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #2ab18b !important;
    border-color: #2ab18b !important;
  }
  .login_info_btn {
    display: flex;
    align-content: center;
  }
}
</style>